var exports = {
  "kL": "xaee3c4fa--689952--container",
  "Yu": "xaee3c4fa--689952--text-block",
  "li": "xaee3c4fa--689952--picture",
  "sT": "xaee3c4fa--689952--promo",
  "Ms": "xaee3c4fa--689952--promo-code",
  "lZ": "xaee3c4fa--689952--phone",
};

module.exports = exports;
